// ============================================================
// PÁGINAS DE SERVICIO — agrega páginas nuevas aquí abajo,
// copiando la estructura de una existente.
//
// Después de agregar una página nueva, recuerda:
// 1. Agregar su "slug" a reactSnap.include en package.json
// 2. Agregar su URL a sitemap.xml
// 3. (Opcional) Agregarla al menú desplegable "Servicios" en Header.jsx
// ============================================================

export const servicePages = [
  {
    slug: "transporte-eventos-congresos",
    metaTitle: "Transporte para Eventos y Congresos en Bogotá | Líneas Doradas",
    metaDescription: "Transporte grupal para eventos corporativos, congresos, conciertos y conferencias en Bogotá. Vans, busetas y buses con conductor y coordinación puerta a puerta.",
    kicker: "Servicio",
    heroBefore: "Transporte para",
    heroHighlight: "eventos y congresos",
    heroAfter: "en Bogotá",
    intro: "Coordinamos el transporte de invitados, ponentes o colaboradores hacia tu evento, congreso, boda o conferencia — con un solo punto de contacto y vehículos que se adaptan al tamaño de tu grupo.",
    paraQuien: [
      "Empresas organizando congresos o conferencias",
      "Agencias de eventos y wedding planners",
      "Hoteles y centros de convenciones que necesitan transporte de invitados",
      "Universidades e instituciones con eventos académicos",
      "Grupos que asisten a conciertos o espectáculos masivos",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros por vehículo — combinamos van, buseta y bus según el tamaño de tu evento.",
    desdeDonde: "Operamos desde Bogotá, con cobertura en municipios cercanos donde se realice tu evento.",
    comoCotizar: "Escríbenos con la fecha, número de invitados y puntos de recogida — te enviamos una cotización en minutos.",
    incluye: [
      "Conductor certificado y vehículo asignado durante todo el evento",
      "Coordinación de horarios de llegada y salida",
      "Punto de encuentro fijo o recogida en varios puntos (hotel, aeropuerto, oficina)",
      "Factura y cotización formal para tu empresa",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Ideal para ponentes o grupos VIP" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos de invitados" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Traslados masivos de asistentes" },
    ],
    venues: [
      { name: "Movistar Arena", address: "Diagonal 61C #26-36, barrio Campín", note: "Escenario cubierto, hasta 14.000 personas" },
      { name: "Coliseo MedPlus", address: "Calle 80 Km 1.5, vía Cota", note: "Escenario cubierto, hasta 20.000 personas" },
      { name: "Estadio El Campín", address: "Carrera 30 (Av. NQS), entre calles 53 y 63", note: "Al aire libre, hasta 39.500 personas" },
      { name: "Vive Claro Distrito Cultural", address: "Entre calles 26 y 53 con carrera 60, barrio Salitre", note: "Distrito cultural al aire libre, hasta 40.000 personas" },
      { name: "Parque Simón Bolívar", address: "Carrera 60 con calle 63, barrio Salitre", note: "Parque metropolitano, eventos masivos al aire libre" },
      { name: "Centro de Eventos Autopista Norte", address: "Autopista Norte Km 19, vía a Chía", note: "Salón para grandes conciertos y eventos empresariales" },
    ],
    serviceType: "Transporte de eventos corporativos",
    areaServedName: "Bogotá",
  },
  {
    slug: "transporte-cundinamarca",
    metaTitle: "Transporte a Cundinamarca desde Bogotá | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para tours y excursiones a Guatavita, Zipaquirá, Tobia, Anapoima y otros municipios de Cundinamarca desde Bogotá.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Cundinamarca",
    heroAfter: "desde Bogotá",
    intro: "Coordina el transporte de tu grupo, familia o empresa hacia los destinos más visitados de Cundinamarca — Guatavita, Zipaquirá, Anapoima, Tobia y más — con un solo vehículo, sin complicaciones.",
    paraQuien: [
      "Familias y grupos de amigos planeando una excursión de un día",
      "Empresas organizando integraciones o actividades de bienestar",
      "Agencias de turismo con tours programados",
      "Colegios con salidas pedagógicas",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia cualquier municipio de Cundinamarca: Guatavita, Zipaquirá, Anapoima, La Mesa, Tobia, Villeta, La Vega, Girardot y más.",
    comoCotizar: "Cuéntanos el destino, la fecha y el número de personas — te respondemos con una cotización en minutos.",
    incluye: [
      "Conductor certificado con experiencia en la ruta",
      "Vehículo asignado para todo el recorrido",
      "Coordinación de horarios de ida y regreso",
      "Flexibilidad para paradas intermedias",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Comodidad para grupos pequeños" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Ideal para excursiones familiares o de amigos" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Grupos grandes, empresas o colegios" },
    ],
    serviceType: "Transporte turístico regional",
    areaServedName: "Cundinamarca",
  },
  {
    slug: "transporte-boyaca",
    metaTitle: "Transporte a Boyacá desde Bogotá | Villa de Leyva, Tunja, Paipa | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para viajes a Villa de Leyva, Tunja, Paipa, Sogamoso y Duitama desde Bogotá. Grupos desde 5 pasajeros.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Boyacá",
    heroAfter: "desde Bogotá",
    intro: "Villa de Leyva, Tunja, Paipa, Sogamoso y Duitama son algunos de los destinos más pedidos por grupos que buscan historia, arquitectura colonial y aguas termales a pocas horas de Bogotá.",
    paraQuien: [
      "Grupos familiares o de amigos en plan de fin de semana",
      "Empresas organizando retiros o convenciones",
      "Agencias de turismo con rutas fijas a Boyacá",
      "Colegios y universidades con salidas académicas",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia Villa de Leyva, Tunja, Paipa, Sogamoso, Duitama y demás municipios de Boyacá.",
    comoCotizar: "Escríbenos con el destino exacto, la fecha y el número de pasajeros para recibir tu cotización.",
    incluye: [
      "Conductor certificado con experiencia en carretera hacia Boyacá",
      "Vehículo asignado para ida y regreso",
      "Coordinación de horarios y paradas",
      "Opción de viaje de un día o de varios días",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Escapadas de fin de semana" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos, retiros empresariales" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Viajes grandes de varios días" },
    ],
    serviceType: "Transporte turístico regional",
    areaServedName: "Boyacá",
  },
  {
    slug: "transporte-costa-caribe",
    metaTitle: "Transporte a Cartagena y Santa Marta desde Bogotá | Líneas Doradas",
    metaDescription: "Alquiler de bus o buseta para viajes en grupo a Cartagena y Santa Marta desde Bogotá. Ideal para giras estudiantiles, empresas y agencias de turismo.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Cartagena y Santa Marta",
    heroAfter: "desde Bogotá",
    intro: "Organizamos viajes largos en grupo hacia la Costa Caribe — Cartagena, Santa Marta y Tayrona — con vehículos preparados para trayectos de varias horas y paradas programadas.",
    paraQuien: [
      "Colegios y universidades con giras estudiantiles",
      "Empresas organizando convenciones o viajes de incentivo",
      "Agencias de turismo con paquetes a la Costa",
      "Grupos familiares o de amigos en viaje de vacaciones",
    ],
    capacidad: "Desde 20 hasta 40 pasajeros — recomendamos bus para este trayecto por la duración del viaje.",
    desdeDonde: "Salidas desde Bogotá hacia Cartagena, Santa Marta y el Parque Tayrona, con paradas programadas en el camino.",
    comoCotizar: "Cuéntanos el destino, fecha de salida y regreso, y número de pasajeros — te enviamos la cotización con el itinerario sugerido.",
    incluye: [
      "Conductor(es) certificados con experiencia en trayectos largos",
      "Paradas programadas para descanso y alimentación",
      "Bus con asientos reclinables para viajes nocturnos",
      "Coordinación de itinerario ida y regreso",
    ],
    vehiculos: [
      { size: "20 – 40 pax", vehicle: "Bus con asientos reclinables", note: "Preparado para trayectos largos y viajes nocturnos" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos con mayor flexibilidad de horario" },
    ],
    serviceType: "Transporte turístico interdepartamental",
    areaServedName: "Bolívar y Magdalena",
  },
  {
    slug: "transporte-tolima",
    metaTitle: "Transporte a Tolima desde Bogotá | Melgar, Ibagué | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para viajes a Melgar, Ibagué y Honda desde Bogotá. Clima cálido a pocas horas de la ciudad, grupos desde 5 pasajeros.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Tolima",
    heroAfter: "desde Bogotá",
    intro: "Melgar, Ibagué y Honda ofrecen clima cálido, fincas y piscinas a poco más de dos horas de Bogotá — uno de los planes más pedidos para descansos de fin de semana en grupo.",
    paraQuien: [
      "Familias y grupos de amigos buscando clima cálido cerca de Bogotá",
      "Empresas organizando integraciones de fin de semana",
      "Agencias de turismo con paquetes a Melgar",
      "Grupos universitarios o colegiales en salida recreativa",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia Melgar, Ibagué, Honda y demás municipios de Tolima.",
    comoCotizar: "Escríbenos con el destino, la fecha y el número de personas para tu cotización.",
    incluye: [
      "Conductor certificado con experiencia en la ruta al Tolima",
      "Vehículo asignado para ida y regreso",
      "Coordinación de horarios y paradas",
      "Flexibilidad para grupos con equipaje o implementos de piscina",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Escapadas familiares o de amigos" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos, fincas con capacidad" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Integraciones empresariales o colegiales" },
    ],
    serviceType: "Transporte turístico regional",
    areaServedName: "Tolima",
  },
  {
    slug: "transporte-eje-cafetero",
    metaTitle: "Transporte al Eje Cafetero desde Bogotá | Salento, Pereira, Armenia | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para viajes al Eje Cafetero desde Bogotá: Salento, Valle de Cocora, Pereira, Armenia y Manizales. Grupos desde 5 pasajeros.",
    kicker: "Destino",
    heroBefore: "Transporte al",
    heroHighlight: "Eje Cafetero",
    heroAfter: "desde Bogotá",
    intro: "Salento, el Valle de Cocora, Pereira, Armenia y Manizales conforman uno de los destinos más pedidos por grupos que buscan paisaje cafetero, naturaleza y gastronomía en un viaje de varios días.",
    paraQuien: [
      "Grupos familiares o de amigos en viaje de varios días",
      "Empresas organizando convenciones o viajes de incentivo",
      "Agencias de turismo con paquetes al Eje Cafetero",
      "Parejas o grupos pequeños buscando fincas cafeteras",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia Salento, Pereira, Armenia, Manizales y demás municipios del Eje Cafetero.",
    comoCotizar: "Escríbenos con el destino exacto, la fecha y el número de pasajeros para recibir tu cotización.",
    incluye: [
      "Conductor certificado con experiencia en carretera de montaña",
      "Vehículo asignado para todo el recorrido",
      "Coordinación de horarios y paradas",
      "Flexibilidad para viajes de varios días con distintas paradas",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Grupos pequeños o parejas" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos, viajes de varios días" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Convenciones o viajes de incentivo grandes" },
    ],
    serviceType: "Transporte turístico regional",
    areaServedName: "Eje Cafetero",
  },
  {
    slug: "transporte-santander",
    metaTitle: "Transporte a Santander desde Bogotá | San Gil, Barichara | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para viajes a San Gil, Barichara y Bucaramanga desde Bogotá. Deportes extremos y turismo cultural, grupos desde 5 pasajeros.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Santander",
    heroAfter: "desde Bogotá",
    intro: "San Gil, Barichara y Bucaramanga combinan deportes extremos, pueblos coloniales y gastronomía santandereana en un viaje de varios días para grupos aventureros.",
    paraQuien: [
      "Grupos de amigos o familias buscando deportes extremos",
      "Empresas organizando retiros o actividades de team building",
      "Agencias de turismo de aventura con rutas a Santander",
      "Grupos interesados en turismo cultural y gastronómico",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia San Gil, Barichara, Bucaramanga y demás municipios de Santander.",
    comoCotizar: "Cuéntanos el destino, la fecha y el número de personas para tu cotización.",
    incluye: [
      "Conductor certificado con experiencia en carretera hacia Santander",
      "Vehículo asignado para ida y regreso",
      "Coordinación de horarios y paradas",
      "Opción de viaje de varios días con distintas paradas",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Grupos pequeños de aventura" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos, retiros empresariales" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Grupos grandes de varios días" },
    ],
    serviceType: "Transporte turístico regional",
    areaServedName: "Santander",
  },
  {
    slug: "transporte-meta",
    metaTitle: "Transporte a Villavicencio y los Llanos desde Bogotá | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para viajes a Villavicencio y los Llanos Orientales desde Bogotá. Grupos desde 5 pasajeros, conductores certificados.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Villavicencio y los Llanos",
    heroAfter: "desde Bogotá",
    intro: "Villavicencio y los Llanos Orientales son un destino cercano a Bogotá con clima cálido, gastronomía llanera y paisajes de sabana — ideal para una escapada de fin de semana.",
    paraQuien: [
      "Familias y grupos de amigos en plan de fin de semana",
      "Empresas organizando integraciones o eventos",
      "Agencias de turismo con rutas a los Llanos",
      "Grupos interesados en gastronomía y cultura llanera",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia Villavicencio y municipios cercanos de los Llanos Orientales.",
    comoCotizar: "Escríbenos con la fecha y el número de pasajeros para recibir tu cotización.",
    incluye: [
      "Conductor certificado con experiencia en la vía al Llano",
      "Vehículo asignado para ida y regreso",
      "Coordinación de horarios y paradas",
      "Flexibilidad para grupos con equipaje o actividades al aire libre",
    ],
    vehiculos: [
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Escapadas de fin de semana" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos, integraciones empresariales" },
      { size: "20 – 40 pax", vehicle: "Bus", note: "Grupos grandes o eventos" },
    ],
    serviceType: "Transporte turístico regional",
    areaServedName: "Meta",
  },
  {
    slug: "transporte-antioquia",
    metaTitle: "Transporte a Medellín y Guatapé desde Bogotá | Líneas Doradas",
    metaDescription: "Alquiler de van, buseta o bus para viajes a Medellín y Guatapé desde Bogotá. Grupos desde 5 pasajeros, ideal para turismo y empresas.",
    kicker: "Destino",
    heroBefore: "Transporte a",
    heroHighlight: "Medellín y Guatapé",
    heroAfter: "desde Bogotá",
    intro: "Medellín y Guatapé son de los destinos más solicitados del país, combinando ciudad moderna, el histórico Peñol-Guatapé y turismo de naturaleza en un viaje de varios días.",
    paraQuien: [
      "Grupos familiares o de amigos en viaje de varios días",
      "Empresas organizando convenciones o viajes de incentivo",
      "Agencias de turismo con paquetes a Medellín y Guatapé",
      "Grupos interesados en turismo urbano y de naturaleza",
    ],
    capacidad: "Desde 5 hasta 40 pasajeros — van, buseta o bus según el tamaño de tu grupo.",
    desdeDonde: "Salidas desde Bogotá hacia Medellín, Guatapé y demás municipios de Antioquia.",
    comoCotizar: "Cuéntanos el destino, la fecha y el número de personas para tu cotización.",
    incluye: [
      "Conductor(es) certificados con experiencia en trayectos largos",
      "Paradas programadas para descanso y alimentación",
      "Vehículo asignado para ida y regreso",
      "Coordinación de itinerario para viajes de varios días",
    ],
    vehiculos: [
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos medianos para viaje largo" },
      { size: "20 – 40 pax", vehicle: "Bus con asientos reclinables", note: "Preparado para trayectos largos" },
    ],
    serviceType: "Transporte turístico interdepartamental",
    areaServedName: "Antioquia",
  },
  {
    slug: "aliados-airbnb",
    metaTitle: "Transporte para Huéspedes Airbnb en Bogotá | Alianza para Anfitriones | Líneas Doradas",
    metaDescription: "Ofrece a tus huéspedes de Airbnb traslados cómodos desde/hacia el aeropuerto y eventos en Bogotá, con 10% de descuento por ser anfitrión aliado.",
    kicker: "Alianza",
    heroBefore: "Transporte para",
    heroHighlight: "huéspedes Airbnb",
    heroAfter: "en Bogotá",
    intro: "Conviértete en nuestro aliado estratégico y ofrece a tus huéspedes un traslado cómodo y confiable desde el aeropuerto, hacia eventos o cualquier destino en Bogotá — con 10% de descuento exclusivo por ser anfitrión aliado.",
    paraQuien: [
      "Anfitriones de Airbnb que reciben huéspedes con regularidad",
      "Administradores de varias propiedades en Bogotá",
      "Huéspedes que buscan un traslado confiable desde el aeropuerto sin complicarse con taxis",
      "Anfitriones que organizan estadías para grupos grandes o eventos",
    ],
    capacidad: "Desde 1 hasta 19 pasajeros — van o buseta según si tu huésped viaja solo, en pareja o en grupo.",
    desdeDonde: "Recogemos y llevamos a tus huéspedes desde o hacia el aeropuerto El Dorado, la terminal de transporte, o cualquier punto de Bogotá donde se encuentre tu propiedad.",
    comoCotizar: "Escríbenos para registrarte como anfitrión aliado — te damos un contacto directo de WhatsApp para que tú o tus huéspedes soliciten el traslado con el 10% de descuento ya aplicado.",
    incluye: [
      "10% de descuento para huéspedes de anfitriones aliados",
      "Recogida puntual con el número de vuelo registrado (para traslados de aeropuerto)",
      "Conductor certificado y vehículo verificado (SOAT, pólizas, revisión tecnomecánica)",
      "Coordinación directa contigo o con tu huésped, sin intermediarios",
      "Disponibilidad para traslados adicionales a eventos o tours durante la estadía",
    ],
    vehiculos: [
      { size: "1 – 4 pax", vehicle: "Van Ejecutiva", note: "Huéspedes individuales o en pareja" },
      { size: "5 – 10 pax", vehicle: "Van Ejecutiva Premium", note: "Grupos pequeños o familias alojadas juntas" },
      { size: "11 – 19 pax", vehicle: "Buseta", note: "Grupos grandes en una misma propiedad o evento" },
    ],
    serviceType: "Transporte de huéspedes y alianza con anfitriones Airbnb",
    areaServedName: "Bogotá",
  },
];
